module.exports = __webpack_public_path__ + "img/first_zhTc.1cfbcf15.png";